/**
 * @file 言語データ 定数管理
 */

export { en } from "./en";
export { ja } from "./ja";
